<template>
  <footer
    class="footer"
    :class="{
      [`footer-${type}`]: type,
      [`footer-${size}`]: size
    }"
    :data-background-color="backgroundColor"
  >

    <template>
      <div class="container flex-direction-row">
        <a
          class="footer-brand"
          href="https://akitorg.ru"
        >Все права на ПО "AkiTorg для ЭВОТОР" принадлежат ИП Данилова Вида Васильевна ИНН 391000028892</a>
        <ul>
          <li>
            <a href="https://wiki.akitorg.ru/" target="_blank">
              WiKi
            </a>
          </li>

        </ul>

      </div>
    </template>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
    size: String
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  }
};
</script>
<style></style>
